export class LoginClass{
    username = '';
    password = '';
    token =  '';
}